__turbopack_context__.v({
  "bannerCaption": "ptgU4G_bannerCaption",
  "bannerSubtitle": "ptgU4G_bannerSubtitle",
  "bannerTitle": "ptgU4G_bannerTitle",
  "sectionWrapper": "ptgU4G_sectionWrapper",
});
